// import preloader from './_components/preloader';
import lenisScroll from './_components/lenisScroll';
import splide from './_components/splide';
import animate from './_components/animate';
import lazy from './_components/lazy';
import pagetop from './_components/pagetop';
import parallax from './_components/parallax';
import smoothScroll from './_components/smoothScroll';

// preloader.init();
splide.init();
animate.init();
lazy.init();
lenisScroll.init();
pagetop.init();
parallax.init();
smoothScroll.init();
